function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import React, { useEffect, useRef, useState } from "react";
import Dropdown from "../uikit/Dropdown/Dropdown";
import DropdownTrigger from "../uikit/Dropdown/DropdownTrigger";
import { twMerge } from "tailwind-merge";
import cc from "classcat";
import { BellAlertIcon } from "@heroicons/react/24/outline";
import ExpandedNavbarNotifications from "./ExpandedNavbarNotifications";
import { notificationsActions, notificationsSelectors } from "../../redux/notifications";
import { useDispatch, useSelector } from "react-redux";
import handleReportError from "../errors/handleReportError";
import DropdownContent from "../uikit/Dropdown/DropdownContent";
import { myCompaniesSelectors } from "../../redux/myCompanies";
import { useResolvedPath } from "react-router-dom";
import Spinner from "../uikit/Spinner";
import { DEFAULT_NOTIFICATIONS_PER_PAGE, NOTIFICATIONS_FILTER_IS_READ } from "./utils";
import { operators } from "../app/utils";
export var notificationType = {
    SUSPICIOUS_LOGIN: "suspicious-login",
    CLIENT_INVOICES_EFACTURA_REJECTED: "client-invoices-efactura-rejected",
    CLIENT_INVOICES_EFACTURA_MESSAGE_RECEIVED: "client-invoices-efactura-message-received",
    SUPPLIER_INVOICES_EFACTURA_IMPORTED: "supplier-invoices-efactura-imported",
    ANAF_SPV_ACTIVATED_BY_ACCOUNTANT: "my-companies-anaf-spv-activated-by-accountant",
    EFACTURA_ACTIVATED_BY_ACCOUNTANT: "my-companies-efactura-activated-by-accountant",
    PRODUCTS_IMPORT_FINISHED: "products-import-finished",
    PRODUCTS_IMPORT_FAILED: "products-import-failed",
    PARTNERS_IMPORT_FINISHED: "partners-import-finished",
    PARTNERS_IMPORT_FAILED: "partners-import-failed",
    MY_COMPANIES_ANAF_SPV_ACTIVATED: "my-companies-anaf-spv-activated",
    MY_COMPANIES_EFACTURA_ACTIVATED: "my-companies-efactura-activated",
    MY_COMPANIES_ANAF_SPV_DEACTIVATED: "my-companies-anaf-spv-deactivated",
    MY_COMPANIES_EFACTURA_DEACTIVATED: "my-companies-efactura-deactivated",
    EXPORT_FINISHED: "export-finished",
    EXPORT_FAILED: "export-failed",
    ETRANSPORT_DECLARATION_IMPORTED: "etransport-declaration-imported",
    ETRANSPORT_DECLARATION_IMPORTED_CORRECTION: "etransport-declaration-imported-correction",
    ETRANSPORT_DECLARATION_REGISTERED: "etransport-declaration-registered",
    ETRANSPORT_DECLARATION_FAILED_TO_REGISTER: "etransport-declaration-failed-to-register",
    ETRANSPORT_DECLARATION_ACCEPTED: "etransport-declaration-accepted",
    ETRANSPORT_DECLARATION_FAILED_TO_SEND: "etransport-declaration-failed-to-send",
    ETRANSPORT_VEHICLE_MODIFICATION_REGISTERED: "etransport-vehicle-modification-registered",
    ETRANSPORT_VEHICLE_MODIFICATION_FAILED_TO_REGISTER: "etransport-vehicle-modification-failed-to-register",
    ETRANSPORT_VEHICLE_MODIFICATION_ACCEPTED: "etransport-vehicle-modification-accepted",
    ETRANSPORT_VEHICLE_MODIFICATION_FAILED_TO_SEND: "etransport-vehicle-modification-failed-to-send",
    ETRANSPORT_CONFIRMATION_REGISTERED: "etransport-transport-confirmation-registered",
    ETRANSPORT_CONFIRMATION_FAILED_TO_REGISTER: "etransport-transport-confirmation-failed-to-register",
    ETRANSPORT_CONFIRMATION_ACCEPTED: "etransport-transport-confirmation-accepted",
    ETRANSPORT_CONFIRMATION_FAILED_TO_SEND: "etransport-transport-confirmation-failed-to-send",
    BILLING_SUBSCRIPTION_PAYMENT_ACCEPTED: "billing-subscription-payment-accepted",
    BILLING_SUBSCRIPTION_PAYMENT_REJECTED: "billing-subscription-payment-rejected",
    BILLING_SUBSCRIPTION_WAS_RENEWED: "billing-subscription-was-renewed",
    BILLING_SUBSCRIPTION_WAS_NOT_RENEWED: "billing-subscription-was-not-renewed",
    BILLING_SUBSCRIPTION_WILL_EXPIRE_SOON: "billing-subscription-will-expire-soon",
    BILLING_SUBSCRIPTION_EXPIRED: "billing-subscription-expired"
};
export default function NavbarNotifications() {
    var dispatch = useDispatch();
    /**
     * We need this to call the notifications api when the user navigates to another page or to the same page
     */ var resolvedPath = useResolvedPath();
    var abortControllerRef = useRef(new AbortController());
    var myCompanyId = useSelector(myCompaniesSelectors.selectedCompanyId);
    var notificationsList = useSelector(notificationsSelectors.getNotificationsList);
    var _useState = _sliced_to_array(useState(true), 2), isLoading = _useState[0], setIsLoading = _useState[1];
    function getNotifications() {
        return _getNotifications.apply(this, arguments);
    }
    function _getNotifications() {
        _getNotifications = _async_to_generator(function() {
            var filters;
            return _ts_generator(this, function(_state) {
                filters = [
                    {
                        field: NOTIFICATIONS_FILTER_IS_READ,
                        operator: operators.EQ,
                        value: false
                    }
                ];
                setIsLoading(true);
                try {
                    dispatch(notificationsActions.getNotifications({
                        myCompanyId: myCompanyId,
                        page: 1,
                        perPage: DEFAULT_NOTIFICATIONS_PER_PAGE,
                        filters: filters
                    }, abortControllerRef.current.signal));
                } catch (error) {
                    console.log(error);
                    handleReportError(error);
                } finally{
                    setIsLoading(false);
                }
                return [
                    2
                ];
            });
        });
        return _getNotifications.apply(this, arguments);
    }
    useEffect(function() {
        getNotifications();
    }, [
        resolvedPath.pathname
    ]);
    useEffect(function() {
        return function() {
            abortControllerRef.current && abortControllerRef.current.abort();
        };
    }, []);
    return /*#__PURE__*/ React.createElement(Dropdown, null, /*#__PURE__*/ React.createElement(DropdownTrigger, {
        onPointerDown: getNotifications
    }, /*#__PURE__*/ React.createElement("button", {
        type: "button",
        className: "relative mt-1 hover:scale-110"
    }, /*#__PURE__*/ React.createElement("div", {
        className: twMerge(cc([
            "ml-3 mr-3 text-blue-550 dark:text-gray-200",
            {
                "mr-6": notificationsList.length > 0
            }
        ]))
    }, /*#__PURE__*/ React.createElement(BellAlertIcon, {
        className: "h-7 w-7 stroke-2"
    })), notificationsList.length > 0 && /*#__PURE__*/ React.createElement("div", {
        className: "absolute -top-1 right-4 rounded-full bg-red-500 p-1 text-sm text-blue-550 dark:text-gray-200"
    }))), /*#__PURE__*/ React.createElement(DropdownContent, {
        align: "end",
        sideOffset: 10,
        alignOffset: 10,
        className: "relative ml-[3vw] max-h-[400px] w-[94vw] p-0 sm:ml-0 sm:w-[450px]"
    }, isLoading && /*#__PURE__*/ React.createElement("div", {
        className: "w-full text-center py-5"
    }, /*#__PURE__*/ React.createElement(Spinner, null)), !isLoading && /*#__PURE__*/ React.createElement(ExpandedNavbarNotifications, null)));
}
